<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">矩阵管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div1">保证金查看</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsList' }">
          <div class="div2">冻结金额</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>冻结金额</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          size="small"
        >
          <el-form-item label="订单编号" prop="brandId">
            <el-input
              placeholder="请输入订单编号"
              v-model="searchForm.orderNo"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input
              v-model="searchForm.goodsName"
              placeholder="请输入商品名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in statuss"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="brandId">
            <el-date-picker
              v-model="updatedTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <!-- <el-button type="primary">导出</el-button> -->
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-loading="loading"
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="page.list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>

<script>
import bond from '../components/bondData.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    bond,
    LbTable
  },
  data () {
    return {
      loading: false,
      updatedTime: [],
      currentIndex: 0,
      name: '---',
      dialogUser: false,
      tableData: [
        {}, {}, {}
      ],
      btns: ['个人信息', '订单信息', '地址信息', '银行卡信息', '佣金记录', '收藏记录', '粉丝记录', '提现记录'],
      createdTime: [],
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        platformId: '',
        orderNo: '',
        goodsName: '',
        type: '',
        status: '',
        updatedTimeStart: '',
        updatedTimeEnd: ''
      },
      types: [{
        id: '1',
        name: '下单',

      },
      {
        id: '2',
        name: '退款',
      }, {
        id: '3',
        name: '取消',
      }],
      statuss: [
        {
          id: '1',
          name: '待审核'
        },
        {
          id: '2',
          name: '已扣除'
        },
        {
          id: '3',
          name: '已退回'
        },
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '时间', prop: 'updatedTime', minWidth: '120' },
        { label: '类型', prop: 'typeLabel', minWidth: '220' },
        { label: '订单编号', prop: 'orderNo', minWidth: '100' },
        { label: '商品', prop: 'goodsName', minWidth: '120' },
        { label: '数量', prop: 'goodsNum', minWidth: '120' },
        { label: '金额', prop: 'amount', minWidth: '120' },
        { label: '状态', prop: 'statusLabel', minWidth: '120' },
        { label: '备注', prop: 'remarks', minWidth: '100' }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created () {
    this.searchForm.platformId = this.$route.query.id
    this.fetchData()
  },
  methods: {
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    fetchData (type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.updatedTime = []
        this.searchForm.platformId = this.$route.query.id
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.searchForm.updatedTimeStart = this.updatedTime[0]
      this.searchForm.updatedTimeEnd = this.updatedTime[1]
      this.$api.getFreezeRecordPageList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        }
      })
    },
    clickbtn (index) {
      this.currentIndex = index
    },
  }
}
</script>
<style scoped>
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
  padding-bottom: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
</style>

